import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import React from "react";

export interface EmptyDashboardPublicationTabProps {
    noResultsTitle: string;
    noResultsSubtitle?: string;
    noResultsCtaTitle?: string;
    noResultsCtaOnClick?: () => void;
}

const CSS_CLASS_NAME = "c-empty-dashboard-publication-tab";
const EmptyDashboardPublicationTab = (
    props: EmptyDashboardPublicationTabProps
) => {
    const {
        noResultsTitle,
        noResultsSubtitle,
        noResultsCtaTitle,
        noResultsCtaOnClick,
    } = props;

    const handleCtaClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.stopPropagation(); // Protects against premature closing in useOutsideClick hook
        if (noResultsCtaOnClick) {
            noResultsCtaOnClick();
        }
    };
    return (
        <section className={CSS_CLASS_NAME}>
            <Heading
                priority={HeadingPriority.Three}
                cssClassName={`${CSS_CLASS_NAME}__title`}>
                {noResultsTitle}
            </Heading>
            {noResultsSubtitle && (
                <Paragraph cssClassName={`${CSS_CLASS_NAME}__subtitle`}>
                    {noResultsSubtitle}
                </Paragraph>
            )}
            {noResultsCtaOnClick && noResultsCtaTitle && (
                <Button
                    cssClassName={`${CSS_CLASS_NAME}__cta`}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Tertiary}
                    onClick={handleCtaClick}>
                    {noResultsCtaTitle}
                </Button>
            )}
        </section>
    );
};

export default EmptyDashboardPublicationTab;
